import { render, staticRenderFns } from "./ModalFirstGreeting.vue?vue&type=template&id=54f9035d&scoped=true&"
import script from "./ModalFirstGreeting.vue?vue&type=script&lang=js&"
export * from "./ModalFirstGreeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f9035d",
  null
  
)

export default component.exports